import { loginApi,registerApi } from '@/api/user'
import {removeUserInfo} from '@/utils/userInfo'
import {removeToken} from "@/utils/token";
import Vue from 'vue'
import router from '@/router/index'
import Router from 'vue-router'
export default {
  login({ commit }, loginFormValue) {
    return new Promise((resolve, reject) => {
      const {uid,upass} = loginFormValue
      loginApi({ uid: uid.trim(), upass: upass }).then(response => {
        commit('SET_TOKEN', response.token)
        commit('SET_USERINFO', response)
        // commit('SET_TOKEN', response)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit('SET_TOKEN', '')
      commit('SET_USERINFO', '')
      removeUserInfo()
      removeToken()
      router.push(`/passport/login?redirect=${router.currentRoute.fullPath}`)
      resolve()
    })
  },
  clearUserInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit('SET_TOKEN', '')
      commit('SET_USERINFO', '')
      removeUserInfo()
      removeToken()
      resolve()
    })
  },
  register({ commit, state },formValue) {
    return new Promise((resolve, reject) => {
      registerApi(formValue).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js